import { render, staticRenderFns } from "./internetMark.vue?vue&type=template&id=099f8828&scoped=true&"
import script from "./internetMark.vue?vue&type=script&lang=js&"
export * from "./internetMark.vue?vue&type=script&lang=js&"
import style0 from "./internetMark.vue?vue&type=style&index=0&id=099f8828&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099f8828",
  null
  
)

export default component.exports